import { render, staticRenderFns } from "./CorporateAuthorEdit.vue?vue&type=template&id=631db838&scoped=true&"
import script from "./CorporateAuthorEdit.vue?vue&type=script&lang=js&"
export * from "./CorporateAuthorEdit.vue?vue&type=script&lang=js&"
import style0 from "./CorporateAuthorEdit.vue?vue&type=style&index=0&id=631db838&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631db838",
  null
  
)

export default component.exports